import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routePaymentEntryCreate,
  detail: routePaymentEntryDetail,
  home: routePaymentEntriesHome,
  root: routePaymentEntriesRoot,
} = createDoctypeRoutes({
  createName: 'new-payment-entry',
  createPath: 'new-payment-entry',
  detailName: 'paymentEntryDetail',
  doctype: DOCTYPES.PAYMENT_ENTRY,
  homeName: 'payment-entries-home',
  path: 'payment-entries',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/paymentEntries/AddPaymentEntry.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/paymentEntries/ViewPaymentEntry.vue'),
    list: async () =>
      await import('@/components/viewsExternal/paymentEntries/PaymentEntryView.vue'),
  },
})

export {
  routePaymentEntriesHome,
  routePaymentEntriesRoot,
  routePaymentEntryCreate,
  routePaymentEntryDetail,
}
